import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { EventPeriod } from '../component/event-period';
import { SeparatorTitle } from '../component/separator-title';
import { competitionBunja } from '../state';
import { competitionContentBunja } from './state';

export const EventTitle = () => {
  const { competitionAtom } = useBunja(competitionBunja);
  const { eventTabTitleAtom, eventTabSubtitleAtom } = useBunja(competitionContentBunja);
  const competition = useAtomValue(competitionAtom);
  const eventTabTitle = useAtomValue(eventTabTitleAtom);
  const eventTabSubtitle = useAtomValue(eventTabSubtitleAtom);

  return (
    <SeparatorTitle
      colorSet='keyColor'
      subtitle={eventTabSubtitle}
      title={eventTabTitle}
      description={<EventPeriod start={competition?.competitionStartTime} end={competition?.competitionEndTime} />}
      css={{ mb: 24 }}
    />
  );
};
